import {
    Box,
    Pagination,
    Paper,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    useMediaQuery,
} from "@mui/material";
import { useLayoutEffect, useMemo, useState } from "react";
import { usePaymentsStore } from "../../../store/payments.store";
import dayjs from "dayjs";
import { Receipt } from "@mui/icons-material";
import { Link } from "react-router-dom";

function capitalizeFirst(str: string) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function HistoryPayments() {
    const [loadingPage, setLoadingPage] = useState(true);
    const isMobile = useMediaQuery("(max-width:1100px)");
    const isSmallMobile = useMediaQuery("(max-width:700px)");

    const { getPeriodPayments, payments, total_payments } = usePaymentsStore();

    const [order, setOrder] = useState<"asc" | "desc">("desc");
    const [page, setPage] = useState(1);

    const handleSortDate = () => {
        setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    };

    useLayoutEffect(() => {
        (async () => {
            try {
                setLoadingPage(true);
                await getPeriodPayments((page - 1) * 12, null, order.toUpperCase());
            } catch (error) {
            } finally {
                setLoadingPage(false);
            }
        })();
    }, [page, order]);

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "30px",
                }}
            >
                <h1>История по счету</h1>
            </Box>
            <TableContainer
                component={Paper}
                sx={{
                    maxWidth: isMobile ? "calc(100vw - 48px)" : "100%",
                    overflowX: "auto",
                }}
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sortDirection={order}>
                                <TableSortLabel
                                    active
                                    direction={order}
                                    onClick={handleSortDate}
                                >
                                    Дата
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="right">Сумма</TableCell>
                            <TableCell align="right"></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    {loadingPage ? (
                        <TableBody>
                            {Array(10)
                                .fill(10)
                                .map((n, v) => {
                                    return (
                                        <TableRow key={v}>
                                            <TableCell>
                                                <Skeleton variant="text" />
                                            </TableCell>
                                            <TableCell align="right">
                                                <Skeleton
                                                    variant="text"
                                                    style={{
                                                        marginLeft: "auto",
                                                        display: "inline-block",
                                                        width: "100px",
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell align="right">
                                                <Skeleton
                                                    variant="text"
                                                    style={{
                                                        marginLeft: "auto",
                                                        display: "inline-block",
                                                        width: "100px",
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell align="right">
                                                <Skeleton
                                                    variant="text"
                                                    style={{
                                                        marginLeft: "auto",
                                                        display: "inline-block",
                                                        width: "140px",
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    ) : (
                        <TableBody>
                            {payments.map((row, i) => (
                                <TableRow key={i}>
                                    <TableCell>
                                        {capitalizeFirst(
                                            dayjs(
                                                `${row.month
                                                    .split(", ")
                                                    .join(" 01 ")}`,
                                            ).format("MMMM, YYYY"),
                                        )}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.total_amount.toFixed(2)}₽
                                    </TableCell>
                                    <TableCell align="right"></TableCell>
                                    <TableCell align="right">
                                        <Link
                                            to={
                                                "/admin/payments/detailed?month=" +
                                                row.month
                                            }
                                            style={{
                                                display: "flex",
                                                gap: "8px",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <Receipt
                                                sx={{
                                                    width: 13,
                                                }}
                                            />
                                            {!isSmallMobile && <>Детализация</>}
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    )}
                </Table>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Pagination
                        sx={{
                            marginTop: "16px",
                            marginBottom: "16px",
                        }}
                        count={
                            Math.floor(total_payments / 12) +
                            (total_payments % 12 == 0 ? 0 : 1)
                        }
                        page={page}
                        onChange={(e, p) => setPage(p)}
                    />
                </Box>
            </TableContainer>
        </Box>
    );
}
